var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3245",
  "data-name": "Group 3245",
  transform: "translate(-16 -200)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2291",
  "data-name": "Rectangle 2291",
  width: 16,
  height: 16,
  transform: "translate(16 200)",
  fill: "#afb6c0",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "dashboard",
  transform: "translate(16 200)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M8,0A8.136,8.136,0,0,0,0,8.267a8.345,8.345,0,0,0,3.2,6.614l0,0A.555.555,0,0,0,3.547,15a.572.572,0,0,0,.562-.581.585.585,0,0,0-.277-.5,7.016,7.016,0,0,1-1.523-1.665L3,11.842a.526.526,0,0,0,.183-.706.491.491,0,0,0-.683-.189l-.691.412a7.2,7.2,0,0,1-.666-2.575h.794a.517.517,0,0,0,0-1.033H1.144a7.279,7.279,0,0,1,.669-2.583l.687.41a.491.491,0,0,0,.683-.189A.526.526,0,0,0,3,4.682l-.686-.409A7.04,7.04,0,0,1,4.136,2.391l.4.709a.491.491,0,0,0,.683.189A.526.526,0,0,0,5.4,2.583L5,1.873a6.645,6.645,0,0,1,2.5-.691V2a.5.5,0,1,0,1,0v-.82a6.678,6.678,0,0,1,2.492.688l-.4.714a.526.526,0,0,0,.183.706.491.491,0,0,0,.683-.189l.4-.714a7.01,7.01,0,0,1,1.828,1.888L13,4.682a.526.526,0,0,0-.183.706.491.491,0,0,0,.683.189l.688-.41a7.237,7.237,0,0,1,.669,2.583h-.794a.517.517,0,0,0,0,1.033h.794a7.257,7.257,0,0,1-.666,2.575l-.691-.412a.491.491,0,0,0-.683.189.526.526,0,0,0,.183.706l.691.412a7.025,7.025,0,0,1-1.566,1.7l0,0a.586.586,0,0,0-.222.463.572.572,0,0,0,.563.581.553.553,0,0,0,.4-.174A8.348,8.348,0,0,0,16,8.267,8.136,8.136,0,0,0,8,0Z",
  fill: "#afb6c0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M3.588.109,1.623,1.679h0a1.093,1.093,0,0,0-.5-.118A1.138,1.138,0,0,0,0,2.712,1.138,1.138,0,0,0,1.125,3.864,1.138,1.138,0,0,0,2.25,2.712a1.1,1.1,0,0,0-.02-.217L4.2.915A.52.52,0,0,0,4.289.2.492.492,0,0,0,3.588.109Z",
  transform: "translate(6.875 5.541)",
  fill: "#afb6c0"
})))));
export default __webpack_public_path__ + "static/media/dashb.64b65fd3.svg";
export { SvgComponent as ReactComponent };